<section class="container support-box">
  <h4>Need Help?</h4>
  <div class="row text-center text-md-start justify-content-center g-4">

    <div class="col-12 col-md-4">
      <div class="d-flex align-items-center">
        <div class="icon-box me-3">
          <img src="assets/images/corporate-account/email.svg" alt="email" />
        </div>
        <div>
          <h6>Send us an email</h6>
          <a href="mailto:support@clooper.com" class="text-success text-decoration-none">support@clooper.com</a>
        </div>
      </div>
    </div>

    <div class="col-12 col-md-4">
      <div class="d-flex align-items-center">
        <div class="icon-box me-3">
          <img src="assets/images/corporate-account/support.svg" alt="chat" />
        </div>
        <div>
          <h6>Live Support</h6>
          <a href="/support-center" target="_blank" class="text-success text-decoration-none">Chat with any of our support team</a>
        </div>
      </div>
    </div>

    <div class="col-12 col-md-4">
      <div class="d-flex align-items-center">
        <div class="icon-box me-3">
          <img src="assets/images/corporate-account/blog.svg" alt="blog" />
        </div>
        <div>
          <h6>Blog Post</h6>
          <a href="https://clooper.com/blog/" target="_blank" class="text-success text-decoration-none">Articles</a>
        </div>
      </div>
    </div>
  </div>
</section>